export default "__VITE_ASSET__DGuWITFT__"